import { format, isValid, parseISO } from 'date-fns';
import Joi from 'joi';

export const AWSDateSchema = Joi.date()
  .empty(Joi.valid(null, ''))
  .custom((value, helpers) => {
    if (value != null)
      if (value instanceof Date) {
        // Joi coerces raw dates to UTC, so preserve the original calendar day.
        const date = typeof helpers.original === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(helpers.original) ? parseISO(helpers.original) : value;
        if (!isValid(date)) return helpers.error('awsDate.notDate');
        return format(date, 'yyyy-MM-dd');
      } else return helpers.error('awsDate.notDate');

    return value;
  })
  .messages({
    'awsDate.notDate': 'The {{#label}} is not a valid date.'
  });

export const AWSDateTimeSchema = Joi.date()
  .empty(Joi.valid(null, ''))
  .custom((value, helpers) => {
    if (value != null)
      if (value instanceof Date) return value.toISOString();
      else return helpers.error('awsDate.notDate');

    return value;
  })
  .messages({
    'awsDate.notDate': 'The {{#label}} is not a valid date.'
  });
